import { Component } from '@angular/core';

@Component({
    selector: 'app-service-unavailable',
    templateUrl: './service-unavailable.component.html',
    standalone: false
})
export class ServiceUnavailableComponent {
  constructor() {}
}
